export enum TestId {
    Announcer = 'announcer',
    AudioMeterSettings = 'audio-meter-settings',
    AudioTestOutput = 'audio-test-output',
    ButtonAccessibilitySettings = 'button-accessibility-settings',
    ButtonAddOverlay = 'button-add-overlay',
    ButtonAddParticipant = 'button-add-participant',
    ButtonAdmitAll = 'button-admit-all',
    ButtonAreYouHostNo = 'button-are-you-host-no',
    ButtonAreYouHostYes = 'button-are-you-host-yes',
    ButtonAskBreakoutHostForHelp = 'button-ask-breakout-host-for-help',
    ButtonAskForHelpModalJoinRoom = 'button-ask-for-help-modal-join-room',
    ButtonAskForHelpModalShowWhoNeedsHelp = 'button-ask-for-help-modal-show-who-needs-help',
    ButtonAskHostToJoinModalCancel = 'button-ask-for-help-modal-ask-host-to-join-cancel',
    ButtonAskHostToJoinModalConfirm = 'button-ask-for-help-modal-ask-host-to-join-confirm',
    ButtonAudioMeter = 'button-audio-meter',
    ButtonAudioMeterMuted = 'button-audio-meter-muted',
    ButtonBlockedPermissions = 'button-blocked-permissions',
    ButtonBreakoutRoomsToolbarRowAddRoom = 'button-breakout-rooms-toolbar-row-add-room',
    ButtonBreakoutRoomsToolbarRowCloseRooms = 'button-breakout-rooms-toolbar-row-close-rooms',
    ButtonBreakoutRoomsToolbarRowEditRooms = 'button-breakout-rooms-toolbar-row-edit-rooms',
    ButtonBreakoutRoomsToolbarRowRoomSettings = 'button-breakout-rooms-toolbar-row-room-settings',
    ButtonBreakoutRoomsToolbarRowShuffle = 'button-breakout-rooms-toolbar-row-shuffle',
    ButtonCameraStepCantSee = 'button-camera-step-cant-see',
    ButtonCameraStepNo = 'button-camera-step-no',
    ButtonCameraStepYes = 'button-camera-step-yes',
    ButtonChatBack = 'button-chat-back',
    ButtonChooseAnother = 'button-choose-another',
    ButtonClearParticipantSearchInput = 'button-clear-participant-search-input',
    ButtonCloseChatPanel = 'button-close-chat-panel',
    ButtonClosePluginPanel = 'button-close-plugin-panel',
    ButtonConfirmCustomStep = 'button-confirm-custom-step',
    ButtonDetectionNext = 'button-detection-next',
    ButtonDisconnectAll = 'button-disconnect-all',
    ButtonDisconnectAllCancel = 'button-disconnect-all-cancel',
    ButtonDisconnectAllConfirm = 'button-disconnect-all-confirm',
    ButtonDualScreenMode = 'button-dual-screen-mode',
    ButtonEnterDTMF = 'button-enter-dtmf',
    ButtonEnterHostPin = 'button-enter-host-pin',
    ButtonFecc = 'button-fecc',
    ButtonFeccPanLeft = 'button-fecc-pan-left',
    ButtonFeccPanRight = 'button-fecc-pan-right',
    ButtonFeccTiltDown = 'button-fecc-tilt-down',
    ButtonFeccTiltUp = 'button-fecc-tilt-up',
    ButtonFeccZoomIn = 'button-fecc-zoom-in',
    ButtonFeccZoomOut = 'button-fecc-zoom-out',
    ButtonFlipCamera = 'button-flip-camera',
    ButtonFreeDialNext = 'button-free-dial-next',
    ButtonGetStarted = 'button-get-started',
    ButtonHideNameOverlay = 'button-hide-name-overlay',
    ButtonLeaveUserMenu = 'button-leave-user-menu',
    ButtonLock = 'button-lock',
    ButtonLowerAllRaisedHands = 'button-lower-all-raised-hands',
    ButtonMeetingDeviceSettings = 'button-meeting-device-settings',
    ButtonMeetingManagerBreakoutRoomsAskingForHelpToolbar = 'button-meeting-manager-breakout-rooms-asking-for-help-toolbar',
    ButtonMeetingManagerBreakoutRoomsMoreMenu = 'button-meeting-manager-breakout-rooms-more-menu',
    ButtonMeetingManagerBreakoutRoomsCloseRooms = 'button-meeting-manager-breakout-rooms-close-rooms',
    ButtonMeetingManagerBreakoutRoomsEditRooms = 'button-meeting-manager-breakout-rooms-edit-rooms',
    ButtonMeetingManagerBreakoutRoomsEditRoomsCancel = 'button-meeting-manager-breakout-rooms-edit-rooms-cancel',
    ButtonMeetingManagerBreakoutRoomsEditRoomsSave = 'button-meeting-manager-breakout-rooms-edit-rooms-save',
    ButtonMeetingManagerRaisedHandToolbar = 'button-meeting-manager-raised-hand-toolbar',
    ButtonMeetingManagerWaitingInLobbyToolbar = 'button-meeting-manager-waiting-in-lobby-toolbar',
    ButtonMicrophoneStepCantHear = 'button-microphone-step-cant-hear',
    ButtonMicrophoneStepNo = 'button-speaker-step-no',
    ButtonMicrophoneStepYes = 'button-speaker-step-yes',
    ButtonOneTimeConfirmationModalNo = 'button-one-time-confirmation-modal-no',
    ButtonOneTimeConfirmationModalYes = 'button-one-time-confirmation-modal-yes',
    ButtonOtherJoiningOptions = 'button-other-joining-options',
    ButtonPresentationModeToggle = 'button-presentation-mode-toggle',
    ButtonRejoin = 'button-rejoin',
    ButtonReloadPage = 'button-reload-page',
    ButtonSelfviewQuality = 'button-selfview-quality',
    ButtonSetExtension = 'button-set-extension',
    ButtonSetName = 'button-set-name',
    ButtonSetPin = 'button-set-pin',
    ButtonSettingsCancel = 'button-settings-cancel',
    ButtonSettingsSave = 'button-settings-save',
    ButtonShowNameOverlay = 'button-show-name-overlay',
    ButtonSignInWith = 'button-sign-in-with',
    ButtonSkipStepByStep = 'button-skip-step-by-step',
    ButtonSpeakerStepCantHear = 'button-speaker-step-cant-hear',
    ButtonSpeakerStepNo = 'button-speaker-step-no',
    ButtonSpeakerStepYes = 'button-speaker-step-yes',
    ButtonStartConference = 'button-start-conference',
    ButtonStartPresentation = 'button-start-presentation',
    ButtonStopPresentation = 'button-stop-presentation',
    ButtonTipsCamera = 'button-tips-camera',
    ButtonTipsMicrophone = 'button-tips-microphone',
    ButtonTipsSpeaker = 'button-tips-speaker',
    ButtonUnlock = 'button-unlock',
    CustomStep = 'custom-step',
    CustomStepPage = 'custom-step-page',
    DesktopMeetingToolbarWrapper = 'desktop-meeting-toolbar-wrapper',
    DTMFNum = 'dtmf-num',
    ErrorMeetingScreen = 'error-meeting-screen',
    ErrorMeetingScreenSubtitle = 'error-meeting-screen-subtitle',
    ErrorMeetingScreenTitle = 'error-meeting-screen-title',
    ErrorScreen = 'error-screen',
    ErrorScreenCode = 'error-screen-code',
    HeaderFreeDial = 'header-free-dial',
    InMeetingVideoWrapper = 'in-meeting-video-wrapper',
    InputExtension = 'input-extension',
    InputFreeDialId = 'input-free-dial-id',
    InputName = 'input-name',
    InputPin = 'input-pin',
    InputParticipantSearch = 'input-participant-search',
    InviteSomeone = 'invite-someone',
    InviteSomeoneCanControlCheckbox = 'invite-someone-can-control-checkbox',
    InviteSomeoneInput = 'invite-someone-input',
    JoinAsGuestLink = 'join-as-guest-link',
    LinkAboutPexip = 'link-about-pexip',
    LinkAllowGuestsToUnmute = 'link-allow-guests-to-unmute',
    LinkDownloadLog = 'link-download-log',
    LinkLanguages = 'link-languages',
    LinkMuteAllGuests = 'link-mute-all-guests',
    LinkQuality = 'link-quality',
    LinkUnmuteAllGuests = 'link-unmute-all-guests',
    LiveCaptions = 'live-captions',
    LiveTranscriptsClosePanelButton = 'transcripts-close-panel-button',
    MediaModal = 'media-modal',
    MeetingHeaderTitle = 'meeting-header-title',
    MeetingManagerParticipantsColumn = 'meeting-manager-participants-column',
    MeetingManagerRaisedHandsColumn = 'meeting-manager-raised-hands-column',
    MeetingManagerWaitingInLobbyColumn = 'meeting-manager-waiting-in-lobby-column',
    MeetingFlowCardWrapper = 'meeting-flow-card-wrapper',
    MicrophoneStepTip = 'microphone-step-tip',
    ModalBreakoutsAskForHelp = 'modal-breakouts-ask-for-help',
    ModalBreakoutsAskHostToJoin = 'modal-breakouts-ask-host-to-join',
    ModalHostPin = 'modal-host-pin',
    ModalSettings = 'modal-settings',
    ModalTransferParticipant = 'modal-transfer-participant',
    ModalDTMF = 'modal-dtmf',
    NotFoundMessage = 'not-found-message',
    OneTimeConfirmationModal = 'one-time-confirmation-modal',
    PanelFecc = 'panel-fecc',
    ParticipantClosePanelButton = 'participant-close-panel-button',
    ParticipantMenuButton = 'participant-menu-button',
    ParticipantPanelExternal = 'participant-panel-external',
    ParticipantPanelHandRaised = 'participant-panel-hand-raised',
    ParticipantPanelInMeeting = 'participant-panel-in-meeting',
    ParticipantPanelMainMenuButton = 'participant-panel-main-menu-button',
    ParticipantPanelWaitingInLobby = 'participant-panel-waiting-in-lobby',
    PermissionsRejectedHeader = 'permissions-rejected-header',
    PluginSidePanel = 'plugin-side-panel',
    PostFeedbackLink = 'post-feedback-link',
    PostMeetingScreen = 'post-meeting-screen',
    SelectEffectBlur = 'select-effect-blur',
    SelectEffectNone = 'select-effect-none',
    SelectEffectOverlay = 'select-effect-overlay',
    SelectEffectUserOverlay = 'select-effect-user-overlay',
    SelectEffectUserOverlayWrapper = 'select-effect-user-overlay-wrapper',
    ClearEffectUserOverlay = 'clear-effect-user-overlay',
    SettingsUserNameStepTextInput = 'settings-user-name-step-text-input',
    SettingsUserNameStepTextInputDisclaimer = 'settings-user-name-step-text-input-disclaimer',
    StepHeaderCamera = 'step-header-camera',
    StepHeaderMicrophone = 'step-header-microphone',
    StepHeaderSpeaker = 'step-header-speaker',
    SubmitFeedback = 'submit-feedback',
    TabSettingsAdvancedSettings = 'tab-settings-advanced-settings',
    TabSettingsJoiningSettings = 'tab-settings-joining-settings',
    TabSettingsMeetingLayout = 'tab-settings-meeting-layout',
    TermsAndServicesLink = 'terms-and-services-link',
    TextLinkLearnRequestPermissions = 'text-link-learn-request-permissions',
    TextLinkUnblockPermissionsVideo = 'text-link-unblock-permissions-video',
    ToastAllGuestsMutedByHost = 'toast-all-guests-muted-by-host',
    ToastAllGuestsUnmutedByHost = 'toast-all-guests-unmuted-by-host',
    ToggleAllowGuestsToUnmute = 'toggle-allow-guests-to-unmute',
    ToggleAlwaysDisplayUiControls = 'toggle-always-display-ui-controls',
    ToggleBrowserCloseConformation = 'toggle-browser-close-confirmation',
    ToggleBrowserCloseConformationRow = 'toggle-browser-close-confirmation-row',
    ToggleDisableKeyboardShortcuts = 'toggle-disable-keyboard-shortcuts',
    ToggleEnforceAudioMute = 'toggle-enforce-audio-mute',
    ToggleEnforceAudioMuteRow = 'toggle-enforce-audio-mute-row',
    ToggleEnforceVideoMute = 'toggle-enforce-video-mute',
    ToggleEnforceVideoMuteRow = 'toggle-enforce-video-mute-row',
    ToggleFecc = 'toggle-fecc',
    ToggleFeccRow = 'toggle-fecc-row',
    ToggleLiveCaptions = 'toggle-live-captions',
    ToggleLiveTranscripts = 'toggle-live-transcripts',
    ToggleLockMeeting = 'toggle-lock-meeting',
    ToggleNoiseSuppression = 'toggle-noise-suppression',
    ToggleNoiseSuppressionRow = 'toggle-noise-suppression-row',
    TogglePreferPresInMix = 'toggle-prefer-in-mix',
    TogglePreferPresInMixRow = 'toggle-prefer-pres-in-mix-row',
    TogglePrioritizeSharingMotion = 'toggle-prioritize-sharing-motion',
    TogglePrioritizeSharingMotionRow = 'toggle-prioritize-sharing-motion-row',
    ToggleShowAuthenticatedParticipants = 'toggle-show-authenticated-participants',
    ToggleShowAuthenticatedParticipantsRow = 'toggle-show-authenticated-participants-row',
    ToggleSpotlight = 'toggle-spotlight',
    TransferModalBtn = 'participant-transfer-btn',
    TransferModalCanControl = 'participant-transfer-can-control',
    TransferModalMeetingId = 'participant-transfer-meeting-id',
    TransferModalPin = 'participant-transfer-pin',
    UnmuteModal = 'unmute-modal',
    UnmuteModalKeepMuted = 'unmute-modal-keep-muted',
    UnmuteModalUnmute = 'unmute-modal-unmute',
    UserMenu = 'user-menu',
    UserMenuAboutPexipModal = 'user-menu-about-pexip-model',
    UserMenuAddParticipant = 'user-menu-add-participant',
    UserMenuButton = 'user-menu-button',
    UserNamePage = 'user-name-page',
    UserNameStep = 'user-name-step',
    UserNameStepInputForm = 'user-name-step-input-form',
    UserNameStepTextInput = 'user-name-step-text-input',
    VideoAndSoundPanel = 'video-and-sound-panel',
}
